import { Icon, Message } from './style'

type Props = {
    oldPresetName?: string
    presetName: string
}

export const PresetCopiedMessage = ({ presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={22} icon="link" width={22} /> A shareable ID to <strong>{presetName}</strong> has
        been copied to your clipboard.
    </Message>
)

export const PresetCreatedMessage = ({ presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={24} icon="flash" width={24} />
        <strong>{presetName}</strong> has been created.
    </Message>
)

export const PresetDeletedMessage = ({ presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={24} icon="flash" width={24} />
        <strong>{presetName}</strong> has been deleted.
    </Message>
)

export const PresetDuplicatedMessage = ({ presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={24} icon="flash" width={24} />
        <strong>{presetName}</strong> has been duplicated.
    </Message>
)

export const PresetImportedMessage = ({ presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={24} icon="flash" width={24} />
        <strong>{presetName}</strong> has been imported to your preset library.
    </Message>
)

export const PresetRenamedMessage = ({ oldPresetName, presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={24} icon="flash" width={24} />
        {oldPresetName} has been renamed to <strong>{presetName}</strong>.
    </Message>
)

export const PresetUpdatedMessage = ({ presetName }: Props) => (
    <Message>
        <Icon color="#fff" height={24} icon="flash" width={24} />
        <strong>{presetName}</strong> has been updated.
    </Message>
)
